import { combineReducers } from 'redux';
import landingReducer from './landingReduer';
import userReducer from './userReducer';

const rootReducer = combineReducers({
    landingPage: landingReducer,
    user: userReducer
});

export default rootReducer;